/**
 * Разделы настройки: список и его тип.
 *
 * Вынесены из экрана, потому что нужны маршрутизатору: иначе адрес
 * `/settings?section=…` тянул бы за собой весь раздел настройки, который
 * грузится по требованию.
 */

export type SettingsSection =
  | "companies"
  | "objects"
  | "directories"
  | "analytics"
  | "templates"
  | "automation"
  | "org"
  | "rights"
  | "workspaces"
  | "imports"
  | "config"
  | "mail"
  | "signin"
  | "api"
  | "audit"
  | "diagnostics";

export const SETTINGS_SECTIONS: SettingsSection[] = [
  "companies",
  "objects",
  "directories",
  "analytics",
  "templates",
  "automation",
  "org",
  "rights",
  "workspaces",
  "imports",
  "config",
  "mail",
  "signin",
  "api",
  "audit",
  "diagnostics",
];
